export default "__VITE_ASSET__B$gTKo2o__"